import MobileBottomPanel from '@ui/MobileBottomPanel/component'

export default (): void => {
  const searchFiltersMobileBottomPanelEl = document.getElementById('search-filters-mobilebottompanel')

  if (searchFiltersMobileBottomPanelEl) {
    MobileBottomPanel(searchFiltersMobileBottomPanelEl)
  }
}
